export const PAGE_TITLE_FIELD: string = "PageTitle";
export const CONFIRM_EXIT_FIELD: string = "ConfirmExitMessage";
